/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetCustomerSingleUxExposureRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {SetCustomerSingleUxExposureResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const setCustomerSingleUxExposure = (request: SetCustomerSingleUxExposureRequest, options?: CashRequestOptions) => post<SetCustomerSingleUxExposureRequest, SetCustomerSingleUxExposureResponse>("/2.0/cash/set-customer-single-ux-exposure", request, {...options, rejectOnError: true })